// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__y2u61","info":"Note_info__3e6w4","note":"Note_note__1jibw","actions":"Note_actions__2oOru"};